import {Column, Row} from "tabloom"
import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text} from "shared/base"
import calculateAverageMood from "./calculate-average-mood"
import {digg} from "diggerize"
import EventEmitter from "events"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import mergeStyles from "@kaspernj/api-maker/build/merge-styles"
import {Pressable} from "react-native"
import React from "react"
import SchoolRow from "./school-row"
import {styles} from "../class-status-route"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"

export default memo(shapeComponent(class RoutesUserClassStatusSchoolGroupRow extends ShapeComponent {
  static propTypes = propTypesExact({
    classStatusRoute: PropTypes.object.isRequired,
    events: PropTypes.instanceOf(EventEmitter).isRequired,
    lastRow: PropTypes.bool.isRequired,
    schoolGroupData: PropTypes.object.isRequired
  })

  setup() {
    const {t} = useI18n({namespace: "js.routes.user.class_status.school_group_row"})

    this.expandIdentifier = React.useMemo(() => `school-group-${this.p.schoolGroupData.schoolGroupId}`, [])
    this.setInstance({t})
    this.useStates({
      expanded: () => {
        const savedExpanded = this.p.classStatusRoute.s.expanded[this.tt.expandIdentifier]

        if (savedExpanded === true || savedExpanded === false) {
          return savedExpanded
        }

        return true
      }
    })
  }

  render() {
    const {t} = this.tt
    const {lastRow, schoolGroupData} = this.p
    const {expanded} = this.s
    const schoolGroup = schoolGroupData.schoolGroup
    const schoolsDatas = Object.values(schoolGroupData.schools)
    const latestMoods = digg(schoolGroupData, "latestMoods")
    const moods = digg(schoolGroupData, "moods")

    return (
      <>
        <Row
          dataSet={this.cache("rowDataSet", {
            expanded,
            schoolGroupId: schoolGroup?.id() || "no-school-group"
          }, [expanded, schoolGroup?.id()])}
          style={this.cache("rowStyle", {
            backgroundColor: "#e5dfff",
            borderColor: "#e5dfff",
            borderBottomWidth: lastRow && !expanded ? 1 : 0,
            borderLeftWidth: 1,
            borderRightWidth: 1,
            borderStyle: "solid",
            borderBottomLeftRadius: lastRow && !expanded ? 24 : 0,
            borderBottomRightRadius: lastRow && !expanded ? 24 : 0
          }, [expanded, lastRow])}
          testID="routes/user/class-status/school-group-row"
        >
          <Column style={this.nameColumnStyle ||= {flexDirection: "row", alignItems: "center", padding: 18}}>
            <Pressable onPress={this.tt.onExpandPress} style={mergeStyles([styles.columnText, {marginRight: 4}])} testID="expand-button">
              <Icon name={expanded ? "chevron-up" : "chevron-down"} />
            </Pressable>
            <Text style={this.nameTextStyle ||= mergeStyles([styles.columnText, {fontWeight: "bold"}])}>
              {schoolGroup ? schoolGroup.name() : t(".no_group")}
            </Text>
          </Column>
          <Column style={this.nicknameColumnStyle ||= {padding: 18}} />
          <Column style={this.teachersColumnStyle ||= {padding: 18}}>
            <Text style={styles.columnText}>{schoolGroupData && Object.keys(schoolGroupData.teachers).length}</Text>
          </Column>
          <Column style={this.topPositiveColumnStyle ||= {padding: 18}}>
            <Text style={styles.columnText}>{digg(schoolGroupData, "topPositiveScoreFactor")?.name()}</Text>
          </Column>
          <Column style={this.topNegativeColumnStyle ||= {padding: 18}}>
            <Text style={styles.columnText}>{digg(schoolGroupData, "topNegativeScoreFactor")?.name()}</Text>
          </Column>
          <Column style={this.moodColumnStyle ||= {padding: 18}}>
            <Text style={styles.columnText}>{moods && calculateAverageMood(moods)}</Text>
          </Column>
          <Column style={this.latestMoodColumnStyle ||= {padding: 18}}>
            <Text style={styles.columnText}>{latestMoods?.length > 0 && calculateAverageMood(latestMoods)}</Text>
          </Column>
          <Column style={this.checkInsCountColumnStyle ||= {padding: 18}}>
            <Text style={styles.columnText}>{digg(schoolGroupData, "checkInsCount")}</Text>
          </Column>
          <Column style={this.brainBreaksCountColumnStyle ||= {padding: 18}}>
            <Text style={styles.columnText}>{digg(schoolGroupData, "brainBreaksCount")}</Text>
          </Column>
          <Column style={this.challengesCountColumnStyle ||= {padding: 18}}>
            <Text style={styles.columnText}>{digg(schoolGroupData, "challengesCount")}</Text>
          </Column>
          <Column style={this.unicornEffectsCountColumnStyle ||= {padding: 18}}>
            <Text style={styles.columnText}>{digg(schoolGroupData, "unicornEffectsCount")}</Text>
          </Column>
          <Column style={this.activeCoursesColumnStyle ||= {padding: 18}}>
            <Text style={styles.columnText}>{digg(schoolGroupData, "activeCourses")}</Text>
          </Column>
          <Column style={this.actionsColumnStyle ||= {padding: 18}} />
        </Row>
        {expanded && schoolsDatas.map((schoolData, schoolIndex) =>
          <SchoolRow
            classStatusRoute={this.p.classStatusRoute}
            key={schoolData.school.id()}
            lastRow={lastRow && (schoolIndex + 1) == schoolsDatas.length}
            schoolData={schoolData}
          />
        )}
      </>
    )
  }

  onExpandPress = () => {
    const {schoolGroupData} = this.p
    const schoolGroupId = digg(schoolGroupData, "schoolGroupId")

    this.setState({expanded: !this.s.expanded})
    this.p.classStatusRoute.updateExpanded({expanded: this.s.expanded, identifier: this.tt.expandIdentifier, modelClass: "Contact", modelId: schoolGroupId})
  }
}))
